import { makeStyles } from 'tss-react/mui';
import { link } from '../../styles/jss/utils';
import { colors, spacing } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme) => ({
    floristSearchContainer: {
        display: 'flex',
    },
    floristNameContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'start',
        marginBottom: spacing.small,
    },
    floristsNumber: Object.assign(Object.assign(Object.assign({ flex: '1 0 36px', display: 'flex', justifyContent: 'center' }, theme.typography.small_bold), theme.typographySpacing.none), { [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, theme.typography.large_bold), theme.typographySpacing.none) }),
    container: {
        border: '1px solid rgba(0,0,0,.1)',
        boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.08), 0px 2px 8px rgba(0, 0, 0, 0.12)',
        borderRadius: '1px',
        width: '100%',
        height: 'auto',
        padding: spacing.xs,
        backgroundColor: colors.supplementary.white,
        [theme.breakpoints.up('md')]: {
            flex: '1 0 50%',
            padding: spacing.medium,
            marginLeft: 0,
        },
        '&:focus': {
            BackgroundColor: colors.grey.grey1,
            boxShadow: '0px 0px 2px #008be9, 0px 2px 2px rgba(0, 0, 0, 0.32)',
        },
    },
    floristDetails: {
        flex: '1 0 calc(100% - 36px)',
        marginBottom: 0,
    },
    floristName: Object.assign(Object.assign(Object.assign({}, theme.typography.small_bold), theme.typographySpacing.none), { color: colors.supplementary.black, [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, theme.typography.large_bold), theme.typographySpacing.none) }),
    distance: Object.assign(Object.assign(Object.assign({}, theme.typography.xxs_regular), theme.typographySpacing.none), { color: colors.grey.grey6, marginTop: '2px', [theme.breakpoints.up('md')]: Object.assign(Object.assign(Object.assign({}, theme.typography.small_regular), theme.typographySpacing.none), { marginTop: spacing.xs }) }),
    floristDetailItem: {
        display: 'flex',
        marginBottom: spacing.xs,
        [theme.breakpoints.up('md')]: {
            marginBottom: '20px',
        },
    },
    workingHours: Object.assign(Object.assign(Object.assign({ color: colors.grey.grey6 }, theme.typography.xxs_regular), theme.typographySpacing.xxs_regular_lg), { [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, theme.typography.small_regular), theme.typographySpacing.small_regular_lg), '& li:not(:last-child)': {
            marginBottom: spacing.xxs,
        } }),
    link: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, link(colors.primary.gold4)), { color: colors.primary.gold5 }), theme.typography.small_regular), theme.typographySpacing.small_regular_sm), { [theme.breakpoints.up('md')]: Object.assign({}, theme.typographySpacing.small_regular_lg) }),
    floristSearchAddress: Object.assign(Object.assign(Object.assign({}, theme.typographySpacing.small_regular_sm), theme.typography.small_regular), { [theme.breakpoints.up('md')]: Object.assign(Object.assign(Object.assign({}, theme.typography.medium_regular), theme.typographySpacing.medium_bold_lg), { marginBottom: spacing.xs }), '& li': {
            color: colors.grey.grey6,
            display: 'inline-block',
            [theme.breakpoints.up('md')]: {
                display: 'block',
            },
            '&:not(:last-child):after': {
                content: "','",
                paddingRight: '6px',
                [theme.breakpoints.up('md')]: {
                    content: "''",
                    paddingRight: 0,
                },
            },
        } }),
}));
export default useStyles;
